import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthService } from './auth.service';

/**
 * Mirror of `authGuard`: prevents already-authenticated users from reaching
 * the public auth screens (login/register/forgot-password). Sends them to
 * the dashboard instead.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.getAccessToken() ? router.createUrlTree(['/dashboard']) : true;
};
